import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { CarouselProps } from './types';

export const Carousel = (props: CarouselProps) => <Slider {...props} />;

export type { CarouselProps };
